import AuthService from './AuthService';

class UsageService {
    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_API_URL;
    }

    // Fetch usage data for a given s3_path with optional date-range filters
    // params: { start_date?: number, end_date?: number } (epoch seconds, UTC)
    async getUsage(s3_path, loginAsUri, params = {}) {
        const token = AuthService.getAccessToken();
        const encodedPath = encodeURIComponent(s3_path);
        const url = `${this.apiBaseUrl}/usage/${encodedPath}` + loginAsUri;

        const options = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const bodyPayload = {};
        if (params && (params.start_date || params.end_date)) {
            if (params.start_date) bodyPayload.start_date = params.start_date;
            if (params.end_date) bodyPayload.end_date = params.end_date;
        }
        if (Object.keys(bodyPayload).length) {
            options.headers['Content-Type'] = 'application/json';
            options.body = JSON.stringify(bodyPayload);
        }

        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }
}

// Also export the class so consumers can instantiate a fresh service if needed
export { UsageService };
const usageService = new UsageService();
export default usageService;
